import { render, staticRenderFns } from "./SendMoney.vue?vue&type=template&id=36165840"
import script from "./SendMoney.vue?vue&type=script&lang=ts"
export * from "./SendMoney.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports